// eslint-disable-next-line no-restricted-imports
import { MutationInput_ClientController_UpdateById_Input_RiskProfile as RiskProfileApi } from 'api/generated/graphql';
import { RiskProfileType } from 'api/types/entity';

export const parseRiskProfileParam = (
  riskProfile?: RiskProfileType
): RiskProfileApi | undefined =>
  riskProfile ? RiskProfileApi[riskProfile] : undefined;
